import { styled } from "@mui/material/styles";
import { Alert, Button, Grid, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";

export const Container = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100%",
}));

export const StyledAlert = styled(Alert)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  alignSelf: "stretch",
}))

export const ChatInputWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  backgroundColor: theme.palette.background.paper,
  zIndex: 10,
}));

export const ChatWrapper = styled("div")(({ theme }) => ({
  gap: 10,
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  height: "100%",
  maxHeight: "100%",
  width: "100%",
  maxWidth: "100%",
  overflowY: "auto",
  paddingBottom: theme.spacing(12), // reserve space for input bar
  scrollBehavior: "smooth",
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const Main = styled(Grid)(({ theme }) => ({
  height: "100%",
  maxHeight: "100%",
  minHeight: 0,
  width: "100%",
  flex: 1,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: theme.spacing(1),
  position: "relative",
}));

export const GridItemWrapper = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  overflowY: "hidden",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(1),
}));

export const LogoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 5,
  alignItems: "center",
  "&:hover": {
    cursor: "pointer",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  border: "none",
  borderRadius: "20px",
  "&:hover": {
    border: "none",
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  display: "inline-block",
  whiteSpace: "pre-line",
  wordBreak: "break-word",
}));

export const CopilotSkeletonWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: 8,
  margin: theme.spacing(1),
}));
